import moment from "moment";

/**
 * Calendar days from today to `date` in the viewer's own timezone, so a
 * trial ending Sep 24 reads "Ends today" all of Sep 24 — the API's
 * 24-hour ceiling (computed when the cached response was built) could say
 * "Ends today" and "1 day" for two rows on the same date (sc-46066).
 * null when there's no date.
 */
const daysUntil = (date) =>
  date
    ? Math.max(
        0,
        moment(date).startOf("day").diff(moment().startOf("day"), "days")
      )
    : null;

export default daysUntil;
